<script>
    import Loader from '../Loader.svelte';
    import SortableTable from '../SortableTable.svelte';
    import Library from '../../Models/libraryORM';
    import {notifier} from '@beyonk/svelte-notifications';

    import {addFormModal} from '../../Forms/ModalFormManager.svelte';
    import {forms} from '../../lib/forms';
    import { confirm } from '../Confirmation.svelte';

    export let params;
    let details;

    let table_fields = [
        {
            field: "name",
            label: "Field Name"
        },
        {
            field: "type",
            label: "Field Type"
        },
        {
            field: "required",
            label: "Required",
            type: "checkbox"
        },
        {
            field: "default_hidden",
            label: "Hide by Default",
            type: 'checkbox'
        }
    ]

    function addField() {
        addFormModal({
            fields: forms['customForm'],
        }).then((data) => {
            if (data.name == "name") {
                notifier.danger("name is a reserved field");
            } else if (data.name == "details") {
                notifier.danger("details is a reserved field");
            }else {
                library.fields.newItem(data);
            }
        }).catch(() => {});

    }

    function editField(field) {
        addFormModal({
            fields: forms['customForm'],
            data: field.details
        }).then((data) => {
            library.save(data).then(() => {
                notifier.success("Field Updated")
            });
        }).catch(() => {});
    }

    function removeField(field) {
        confirm(`Are you sure you want to remove field "${field.details.name}"?`).then(() => {
            field.delete().then(() => {
                notifier.success("Field Removed")
            })
        }).catch(() => {})
    }

    function updateLibraryName() {
        Library.save(details);
    }

    function moveField(evt) {
        let fields = [...$library_store.fields];

        if (evt.detail.newIndex == evt.detail.oldIndex) return;

        let newIndex = evt.detail.newIndex;
        let oldIndex = evt.detail.oldIndex;

        let after, before;
        if (newIndex == 0) {
            before = fields[1];
        } else if (newIndex == fields.length) {
            after = fields[newIndex];
        } else {
            if (newIndex < oldIndex) {
                after = fields[newIndex - 1];
                before = fields[newIndex];
            } else {
                after = fields[newIndex];
                before = fields[newIndex + 1];
            }
        }

        $library_store.fields.moveItem(fields[oldIndex], after, before);
    }

    function load_details(store) {
        if (!store) return;
        details = store.details;
    }

    $: library = new Library(params.id);
    $: library_store = library.store;

    $: load_details($library_store)

    // $: console.log($library_store && [...$library_store.fields].map(f => `${f.details.name} - ${f.details.rank_}`));
</script>

<Loader loading={!$library_store}>
    <div class="container is-fluid">
        <h1 class="title is-1">
            Edit Library
            <a href="#/libraries" class="button is-pulled-right">Close</a>
        </h1>

        <div class="field is-horizontal is-large">
            <div class="field-label is-narrow is-large">
                <label class="label">Library Name</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <input class="input is-large" type="text" bind:value={details.name} on:blur={updateLibraryName}>
                    </div>
                </div>
            </div>
        </div>

        <SortableTable sortFields={table_fields} tableData={[...$library_store.fields]} rowKey="id" ORM="true" showHideFields={false} sortable={true} on:sortEnd={moveField}>
            <tr slot="topRow">
                <td>name</td>
                <td>text</td>
                <td class="is-v-centered is-h-centered"><input type="checkbox" checked="true" on:click|preventDefault></td>
                <td class="is-v-centered is-h-centered"><input type="checkbox" checked="false" on:click|preventDefault></td>
                <td></td>
            </tr>
            <div slot="rowActions" let:row={field}>
                <button class="button is-info" on:click={() => editField(field)}>Edit</button>
                <button class="button is-danger" on:click={() => removeField(field)}>Delete</button>
            </div>
            <div slot="footerActions">
                <div class="buttons is-right">
                    <button class="button is-success" on:click={addField}>Add Field</button>
                </div>
            </div>
            <div slot="filterActions">
                <div class="buttons is-right">
                    <button class="button is-success" on:click={addField}>Add Field</button>
                </div>
            </div>
        </SortableTable>
    </div>
</Loader>